/**
 * Sprint 91 — Shared markdown → HTML renderer.
 * Extracted from MarkdownEditor so the public NewsDetail (and any other reader)
 * renders exactly like the admin preview. Escapes HTML first to prevent XSS.
 *
 * Supports: # ## ### headings, **bold**, *italic*, [text](url), - list items, line breaks.
 */
export function renderMarkdown(md) {
  if (!md) return "";
  const lines = String(md)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .split("\n");

  // Wrap consecutive "- " lines into <ul><li>…</li></ul>
  const out = [];
  let inList = false;
  for (const raw of lines) {
    const line = raw.trimEnd();
    const isBullet = /^\s*-\s+.+/.test(line);
    if (isBullet) {
      if (!inList) { out.push("<ul class=\"mt-2 ml-5 list-disc space-y-1\">"); inList = true; }
      out.push(`<li>${line.replace(/^\s*-\s+/, "")}</li>`);
    } else {
      if (inList) { out.push("</ul>"); inList = false; }
      out.push(line);
    }
  }
  if (inList) out.push("</ul>");
  let html = out.join("\n");

  html = html
    .replace(/^### (.*)$/gm, '<h3 class="mt-4 text-lg font-bold">$1</h3>')
    .replace(/^## (.*)$/gm, '<h2 class="mt-5 text-xl font-bold">$1</h2>')
    .replace(/^# (.*)$/gm, '<h1 class="mt-6 text-2xl font-bold">$1</h1>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer" class="text-wine-600 underline">$1</a>')
    .replace(/\n\n/g, '</p><p class="mt-3">')
    .replace(/\n/g, "<br/>");
  return `<p>${html}</p>`;
}
